// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"3ae1149f","787":"2cc56198"}[chunkId] + ".chunk.js";
};